<template>
<div class="ui middle aligned center aligned grid">
  <div class="login">
    <h2 class="ui header">
        <div class="content">
          <img class="name" src="../assets/name.png">
        </div>
    </h2>
    <div class="ui error message" v-if="error">{{ errorText }}</div>

    <div class="ui stacked secondary  segment">
      <form class="ui large form" @submit.prevent="login">
          <div class="field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input type="text" name="username" v-model="username" placeholder="Username" required>
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="password" v-model="password" placeholder="Password" required>
            </div>
          </div>
          <button class="ui fluid large teal button hapiick" type="submit">Login</button>
      </form>

      <div class="fieldRecuperarPass">
        <a class="changePass" v-on:click="showInputInsertEmail()">Recuperar Contraseña</a>
      </div>

      <div v-if="show" class='inputRecuperarPass'>
        <div :class="classText" v-if="errorEmail">{{ errorTextEmail }}</div>

        <form class="ui large form" @submit.prevent="checkemail">
          <div class="field">
            <div class="ui left icon input">
              <i class="mail icon"></i>
                <input type="text" name="email" v-model="email" placeholder="Introducir Email o Username" required>
              </div>
          </div>

          <div class="field">
              <button class="ui fluid large teal button hapiick" type="submit">Recuperar Contraseña</button>
          </div>
        </form>
      </div>
    </div>

    <div class="footer">
      <a class="footerText" href="http://hapiick.com"><i class="home icon"></i>www.hapiick.com</a>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi, setToken } from '@/api/hapiickApi';
export default {
  name: 'Login',
  data() {
    return {
      errorText: null,
      error: false,
      username: null,
      password: null,
      show: false,
      email: null,
      errorTextEmail: null,
      errorEmail: false,
      classText: null,
    }
  },
  created() {
    this.checkLogin()
  },
  methods: {
    checkLogin() {
      //console.log('checkLogin');
      if (localStorage.token && localStorage.admin && localStorage.company && !JSON.parse(localStorage.admin).change_pass) {
        this.$router.replace('/dashboard')
      }
    },
    login() {
      hapiickApi().post('/v2/login', {
        username: this.username,
        password: this.password
      })
      .then(request => {
        this.loginSuccessful(request)
      })
      .catch((error) => {
        //this.loginFailed(error)
        this.error = true

        if(error.request) {
          if (error.request.status == 429) {
            let response = JSON.parse(error.request.response)
            this.errorText  = response.message
          } else {
            this.errorText = 'Ha ocurrido un error inesperado.'
          }
        }
      })
      //.catch(e => console.log(e))
    },
    loginSuccessful(req) {
      if (req.data.status !== 'OK') {
        this.loginFailed(req.data.message)
        return
      }
      this.error = false

      localStorage.token = req.data.data.access_token
      localStorage.admin = JSON.stringify(req.data.data.admin.Administrator)
      localStorage.company = JSON.stringify(req.data.data.admin.AdminCompany)
      localStorage.theme = JSON.stringify(req.data.data.admin.AdminTheme)

      setToken(localStorage.token)

      // localStorage.color = req.data.data.admin.AdminTheme.primary_color
      //this.setStyle(req.data.data.admin.AdminTheme);

      if (req.data.data.admin.Administrator.change_pass) {
        this.$router.replace(this.$route.query.redirect || '/changepass')
      } else {
        this.$router.replace(this.$route.query.redirect || '/dashboard')
      }
    },
    loginFailed(msg) {
      this.error = true
      //this.errorText = 'Login failed!'

      this.errorText = msg
     
      delete localStorage.token
      delete localStorage.admin
      delete localStorage.company
      delete localStorage.theme
    },
    showInputInsertEmail() {
      this.show = !this.show;
    },
    checkemail() {
      hapiickApi().post('/v1/users/check-email', {
        email: this.email
      })
      .then(request => {
        this.checkEmailSuccessFul(request.data)
        }
      )
      .catch(
        () => this.checkEmailFailed()
      )
    },
    checkEmailSuccessFul(req) {     
      if(req.status === 'OK') { //Email enviado OK
        this.errorEmail = true
        this.errorTextEmail = req.message
        this.classText = 'ui success message'
      } else { //Email enviado KO
        this.errorEmail = true
        this.errorTextEmail = req.message
        this.classText = 'ui error message'
      }
    },
    checkEmailFailed(message) {
      this.errorEmail = true
      this.errorTextEmail = message
      this.classText = 'ui error message'
    },
    setStyle(theme) {
      let color = (theme.primary_color) ? theme.primary_color : this.$primary_color_default;
      // this.$store.commit('set_primary_color', color)
      //document.documentElement.style.setProperty('--var-color', color)
    } 
  }
}
</script>
<style scoped>
a {
  color: darkslategrey;
}

.hapiick {
  color: black !important;
  background-color: #00f9a9 !important;
}

.footer {
  margin-top: 20px;
}

.footerText {
  font-size: 12px;
  font-weight: 300;
  color: black;
}

.name {
  width: 200px;
}

.login {
  text-align: center;
  margin-top: 25vh;
  width: 450px;
}

.fieldRecuperarPass {
  margin-top: 2vh;
  font-size: 15px;
}

.inputRecuperarPass {
  margin-top: 2vh;
}

@media only screen and (max-width: 600px) {
  .login {
    text-align: center;
    margin-top: 25vh;
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue